import { jsx as _jsx } from "react/jsx-runtime";
import { addEventListener } from 'consolidated-events';
import { useEffect } from 'react';
import { TaskId } from 'api/models';
import { SpaceTabAPI } from 'api/space';
import { SpaceTabType } from 'api/space/space-tab';
import { useIsResponsive } from 'hooks/use-media-query';
import { useNavigateToTask } from 'hooks/use-navigate-to-task';
import { MentionType } from 'vendor/ckeditor/plugins/mention/types';
// MentionService will show task and document pane whenever
// user clicks on a mention be it on a document, any rte editor or a
// simple html.
export const MentionService = ()=>{
    const navigateToTask = useNavigateToTask();
    const isResponsive = useIsResponsive();
    useEffect(()=>{
        const openTask = (task)=>isResponsive ? ()=>{} : navigateToTask(TaskId(task.project.projectId, task.taskId));
        const handleClick = async (event)=>{
            var _event_target_href;
            const { rocketlaneMentionType, rocketlaneMentionSubType, rocketlaneMentionObjectId, rocketlaneMentionProjectId, rocketlaneMentionSpaceId } = event.target.dataset;
            const splitURL = (_event_target_href = event.target.href) === null || _event_target_href === void 0 ? void 0 : _event_target_href.split('/');
            /*
      This block of code is to provide backwards compatability to the spacetab reference links
      that got created when we add task using the balloon toolbar which pops up when highlighting
      text within the spaceTab content and appears in the task description section.
      */ if (splitURL && splitURL[3] === 'projects' && splitURL[5] === 'spaces' && splitURL[7] === 'tabs') {
                event.preventDefault();
                const host = window.location.origin;
                const urlPrefix = `${host}/projects`;
                const projectId = splitURL[4];
                const spaceTabId = splitURL[8];
                const response = await SpaceTabAPI.getSpaceId(spaceTabId);
                const { spaceId } = response.space;
                const url = `${urlPrefix}/${projectId}/spaces/${spaceId}/tabs/${spaceTabId}`;
                if (!isResponsive) {
                    const win = window.open(url, '_blank', 'noopener');
                    win === null || win === void 0 ? void 0 : win.focus();
                }
            }
            if (event.target.matches('a[data-mention]')) {
                event.preventDefault();
                if (rocketlaneMentionType === MentionType.Task) {
                    const task = {
                        taskId: rocketlaneMentionObjectId,
                        project: {
                            projectId: rocketlaneMentionProjectId
                        }
                    };
                    openTask(task);
                }
                if (rocketlaneMentionType === MentionType.SpaceTab) {
                    const host = window.location.origin;
                    let urlPrefix = `${host}/projects`;
                    let url;
                    let _spaceId;
                    if (rocketlaneMentionSubType === SpaceTabType.DocumentTemplate) {
                        url = `${host}/templates/documents/${rocketlaneMentionObjectId}`;
                    } else {
                        if (rocketlaneMentionSubType === SpaceTabType.ProjectTemplate) {
                            urlPrefix = `${host}/templates/projects`;
                            _spaceId = rocketlaneMentionSpaceId;
                        } else {
                            const response = await SpaceTabAPI.getSpaceId(rocketlaneMentionObjectId);
                            const { spaceId } = response.space;
                            _spaceId = spaceId;
                        }
                        url = `${urlPrefix}/${rocketlaneMentionProjectId}/spaces/${_spaceId}/tabs/${rocketlaneMentionObjectId}`;
                    }
                    if (!isResponsive) {
                        const win = window.open(url, '_blank', 'noopener');
                        win === null || win === void 0 ? void 0 : win.focus();
                    }
                }
            }
        };
        const removeEventListner = addEventListener(document, 'click', handleClick);
        return ()=>{
            removeEventListner();
        };
    }, [
        navigateToTask,
        isResponsive
    ]);
    return /*#__PURE__*/ _jsx("div", {});
};
